export const DISCOUNT_TEMPLATE_TYPE = {
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
  FREE_SHIPPING: 'FREE_SHIPPING',
};

export const DISCOUNT_TEMPLATE_PRODUCTS = {
  DIGITALS: 'DIGITALS',
  PRINTS: 'PRINTS',
  ALL: 'ALL',
};

export const DISCOUNT_TEMPLATE_PRODUCTS_LABELS = {
  DIGITALS: 'Digital products',
  PRINTS: 'Prints & physical products',
  ALL: 'All products',
};
